import { useState } from 'react';
import { casinosData } from '../../../mocks/casinos';

export default function TopCasinos() {
  const [filter, setFilter] = useState('all');
  
  const filteredCasinos = filter === 'all' 
    ? casinosData 
    : casinosData.filter(c => c.difficulty === filter);

  return (
    <section id="top-casinos" className="py-20 px-4 sm:px-6 lg:px-8 animate-on-scroll opacity-0">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Главный рейтинг казино онлайн с бонусами
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Рейтинг по индексу выгодности бонуса. Мы учли не только размер бонуса, но и реальную сумму, которую вы сможете вывести после отыгрыша.
          </p>
        </div>

        <div className="flex flex-wrap gap-3 justify-center mb-10">
          <button
            onClick={() => setFilter('all')}
            className={`px-6 py-3 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
              filter === 'all'
                ? 'bg-orange-500 text-white shadow-lg'
                : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'
            }`}
          >
            Все казино онлайн
          </button>
          <button
            onClick={() => setFilter('Легко')}
            className={`px-6 py-3 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
              filter === 'Легко'
                ? 'bg-orange-500 text-white shadow-lg'
                : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'
            }`}
          >
            Легкий отыгрыш
          </button>
          <button
            onClick={() => setFilter('Средне')}
            className={`px-6 py-3 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
              filter === 'Средне'
                ? 'bg-orange-500 text-white shadow-lg'
                : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'
            }`}
          >
            Средняя сложность
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredCasinos.map((casino, index) => (
            <div
              key={casino.id}
              className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 hover:scale-105 group"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="bg-gradient-to-br from-orange-500 to-orange-600 p-6 relative overflow-hidden">
                <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16"></div>
                <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full -ml-12 -mb-12"></div>
                
                <div className="relative flex items-center justify-between mb-4">
                  <div className="w-16 h-16 bg-white rounded-xl flex items-center justify-center shadow-lg">
                    <img src={casino.logo} alt={casino.name} className="w-14 h-14 object-contain" />
                  </div>
                  <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
                    <div className="flex items-center gap-1">
                      <i className="ri-star-fill text-yellow-300 text-sm"></i>
                      <span className="text-white font-bold">{casino.rating}</span>
                    </div>
                  </div>
                </div>
                
                <h3 className="text-2xl font-bold text-white mb-2">{casino.name}</h3>
                <div className="text-3xl font-bold text-white mb-1">{casino.bonus}</div>
                <div className="text-white/90 text-sm">Приветственный пакет</div>
              </div>

              <div className="p-6 space-y-4">
                <div className="flex items-center justify-between pb-4 border-b border-gray-100">
                  <span className="text-gray-600 text-sm">Реальная ценность:</span>
                  <span className="text-xl font-bold text-orange-600">{casino.realValue}</span>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <div className="text-xs text-gray-500 mb-1">Сложность отыгрыша</div>
                    <div className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${
                      casino.difficulty === 'Легко' ? 'bg-green-100 text-green-700' :
                      casino.difficulty === 'Средне' ? 'bg-yellow-100 text-yellow-700' :
                      'bg-red-100 text-red-700'
                    }`}>
                      {casino.difficulty}
                    </div>
                  </div>
                  <div>
                    <div className="text-xs text-gray-500 mb-1">Вейджер</div>
                    <div className="text-lg font-bold text-gray-900">{casino.wager}</div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <div className="text-gray-500 mb-1">Мин. депозит</div>
                    <div className="font-semibold text-gray-900">{casino.minDeposit}</div>
                  </div>
                  <div>
                    <div className="text-gray-500 mb-1">Макс. бонус</div>
                    <div className="font-semibold text-gray-900">{casino.maxBonus}</div>
                  </div>
                </div>

                <div className="pt-2">
                  <div className="text-xs text-gray-500 mb-2">Доступные игры</div>
                  <div className="text-sm font-medium text-gray-700">{casino.games}</div>
                </div>

                <a
                  href={casino.url}
                  target="_blank"
                  rel="nofollow sponsored noopener noreferrer"
                  className="block w-full py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white text-center font-bold rounded-xl hover:from-orange-600 hover:to-orange-700 transition-all duration-300 shadow-lg hover:shadow-xl group-hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  Забрать выгодный бонус
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-orange-50 to-yellow-50 rounded-2xl p-8 border border-orange-100">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Как мы рассчитываем индекс выгодности бонуса?
          </h3>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="flex gap-4">
              <div className="w-12 h-12 bg-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-calculator-line text-2xl text-white"></i>
              </div>
              <div>
                <div className="font-semibold text-gray-900 mb-1">Размер бонуса</div>
                <div className="text-sm text-gray-600">Учитываем максимальную сумму и процент от депозита</div>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="w-12 h-12 bg-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-refresh-line text-2xl text-white"></i>
              </div>
              <div>
                <div className="font-semibold text-gray-900 mb-1">Условия отыгрыша</div>
                <div className="text-sm text-gray-600">Анализируем вейджер и ограничения по ставкам</div>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="w-12 h-12 bg-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
              </div>
              <div>
                <div className="font-semibold text-gray-900 mb-1">Реальная выгода</div>
                <div className="text-sm text-gray-600">Рассчитываем сумму, которую можно реально вывести</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}